const Hashbar = () => {
    const el = document.querySelector('body');

    const updateHashbarHeight = () => {
        const hashbar = document.querySelector('.hthb-notification');
        if (!hashbar) return;
        const hashbarHeight = hashbar.offsetHeight;

        document.body.style.setProperty(
            '--hashbar-height',
            `${hashbarHeight || 0}px`,
        );
    }

    const observer = new MutationObserver((mutations) => {
        mutations.forEach(mutation => {
            if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
                if (el.classList.contains('hthb') || el.classList.contains('has-hthb')) {
                    if (!el.classList.contains('has-hthb')) {
                        el.classList.add('has-hthb');
                    }
                    setTimeout(() => {
                        updateHashbarHeight();
                    }, 500)
                }
            }
        });
    });
    observer.observe(el, {
        attributes: true,
        attributeFilter: ['class'],
    });

    window.addEventListener('resize', updateHashbarHeight);
    document.addEventListener('forceResizeEvent', updateHashbarHeight);
}

export default Hashbar;